import { callApi } from "utils/ContentoApi"

import type { PlanningDefaults } from "./planning"

export const fetchPlanningDefaults = (accountId: string): Promise<PlanningDefaults> =>
  callApi({ method: "get", url: `content-factory/accounts/${accountId}/planningDefaults` }, true, true)
